import ClipLoader from "react-spinners/ClipLoader";

export default function CircularProgressCard({ textSize = 'text-base', loading = false, disabledDetails = false, textColor = 'text-white', buttonLabel, attivi, totale, text1, text2, text3, label, onClick = () => { }, size = 140, strokeWidth = 16, fill = '#8891A2', viewDetails = true }) {

  const percentage = (attivi / totale) * 100 || 0
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;

  // Offset per la parte "piena" della progress bar circolare
  const offset = circumference - (percentage / 100) * circumference;

  return (
    <div className="h-fit w-full max-w-[240px] flex flex-col items-center justify-center space-y-2 rounded-md p-2">
      {/* Contenitore relativo per il cerchio */}
      <div className="relative flex-shrink-0 flex items-center justify-center">
        <svg width={size} height={size} className="block">
          <defs>
            {/* Gradiente lineare (da giallo chiaro a giallo più scuro) */}
            <linearGradient id="progressGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#FFE35F" />
              <stop offset="100%" stopColor="#FCB500" />
            </linearGradient>
            <filter id="shadow">
              <feDropShadow dx="0" dy="0" stdDeviation="4" floodColor="#000000" floodOpacity="0.3" />
            </filter>
            <filter id="innerShadow" x="-50%" y="-50%" width="200%" height="200%">
              <feGaussianBlur in="SourceAlpha" stdDeviation="4" result="blur" />
              <feOffset dx="0" dy="2" />
              <feComposite in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowDiff" />
              <feFlood floodColor="#000000" floodOpacity="0.3" />
              <feComposite in2="shadowDiff" operator="in" />
              <feComposite in2="SourceGraphic" operator="over" />
            </filter>
          </defs>

          {/* Cerchio di base (trail) */}
          <circle
            stroke="#e5e7eb"   // gray-200
            fill={fill}    // colore di sfondo interno
            strokeWidth={strokeWidth}
            cx={size / 2}
            cy={size / 2}
            r={radius}
            filter="url(#innerShadow)"
          />

          {/* Cerchio “progress” con gradiente */}
          <circle
            stroke="url(#progressGradient)"
            fill="none"
            strokeWidth={strokeWidth}
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            strokeLinecap="round"
            cx={size / 2}
            cy={size / 2}
            r={radius}
            className="transition-all duration-500"
          // filter="url(#innerShadow)"
          />
        </svg>

        {/* Testo al centro: "7 su 10 ATTIVI" */}
        <div className={`absolute inset-0 flex flex-col items-center justify-center font-raleway leading-[100%] tracking-[0.25px] ${textColor} ${textSize} font-semibold`}>
          {loading && !text1 ? (
            <ClipLoader color="#FFFFFF" loading={true} size={40} />
          ) : !text1 && !loading ? (
            <div className="flex flex-col justify-center items-center text-gray-500 text-xs text-center px-4">
              <span>Nessun dato</span>
              <span>disponibile</span>
            </div>
          ) : (
            <div className="flex flex-col justify-center items-center">
              {text1 && <div>{text1}</div>}
              {text2 && <div className="text-sm">{text2}</div>}
              {text3 && <div className="text-sm">{text3}</div>}
            </div>
          )}
        </div>
      </div>

      {/* Titolo sotto il cerchio */}
      <h3 className="text-gray-800 text-sm font-semibold flex justify-center items-center text-center">{label}</h3>

      {/* Pulsante “Dettagli” */}
      {viewDetails && (
        <button
          disabled={disabledDetails}
          className={`border px-3 py-2 text-xs rounded transition duration-200 ease-in-out transform ${disabledDetails ? 'border-gray-300 bg-gray-100 text-gray-400 cursor-not-allowed' : 'border-gray-400 hover:bg-gray-100 hover:text-gray-800 hover:scale-105 hover:shadow-md'}`}
          onClick={onClick}
        >
          {buttonLabel}
        </button>
      )}
    </div>
  );
}
